import { v4 as uuid } from "uuid";
import RolesAPI from "@/api/RolesAPI";
import { createSlice, nanoid, createAsyncThunk } from '@reduxjs/toolkit'
import {ROLES} from "@/actions/globalConst";
import { CompanyModel } from "@/models/Company";
import { RolesModel } from "@/models/Roles";

export const initialState = {
    roles: [],
    abilities: [],
    storage: [],
    selected: new RolesModel(),
    view: ROLES.VIEW_OVERVIEW,
    apiState: ROLES.API_INIT,
    key: "",
    error: null
};

const RolesReducer = createSlice({
  name: 'roles',
  initialState,
  reducers: {
      newRol(state, action) {
          state.selected = new RolesModel();
          state.selected.setAbilities(state.abilities);
      },
      cancel(state, action) {
          state.selected = new RolesModel();
          state.selected.setAbilities(state.abilities);
          state.apiState = ROLES.API_READY;
          state.view = ROLES.VIEW_OVERVIEW;
      }
      
    // omit existing reducers here
  },
  extraReducers(builder) {
    builder.addCase(rolesEdit.fulfilled, (state, action) => {
        if(action.payload.data.role) {
            state.selected = new RolesModel(action.payload.data.role);
            state.selected.setAbilities(state.abilities, action.payload.data.role.abilities);
            }
        if(action.payload.data.abilities) {
         state.abilities = action.payload.data.abilities;
        }
        state.apiState = ROLES.API_READY;
        state.view = ROLES.VIEW_EDIT,
      state.key = uuid().slice(0, 8);
      state.error = null;
    }).addCase(rolesEdit.rejected, (state, action) => {
        state.error = action.payload;
        state.key = uuid().slice(0, 8);
    }).addCase(rolesEdit.pending, (state, action) => {
        state.apiState = ROLES.API_PROCESSING;
    });

    builder.addCase(getRoleForUser.fulfilled, (state, action) => {
        if(action.payload.data.abilities) {
            state.selected = new RolesModel();
            let userAbilities = (action.payload.data?.userFields?.rights?.abilities) ? action.payload.data?.userFields?.rights?.abilities : [];
            if(action.payload.data?.userFields?.rights?.storage) {
                state.selected.storage = action.payload.data?.userFields?.rights?.storage;
            }
            state.selected.setAbilities(action.payload.data.abilities, userAbilities);
            }
        if(action.payload.data.abilities) {
         state.abilities = action.payload.data.abilities;
        }
        if(action.payload.data.storage) {
         state.storage = action.payload.data.storage;
        }
        state.apiState = ROLES.API_READY;
//        state.view = ROLES.VIEW_EDIT,
      state.key = uuid().slice(0, 8);
      state.error = null;
    }).addCase(getRoleForUser.rejected, (state, action) => {
        state.error = action.payload;
        state.key = uuid().slice(0, 8);
    }).addCase(getRoleForUser.pending, (state, action) => {
        state.apiState = ROLES.API_PROCESSING;
    });

    builder.addCase(roleStore.fulfilled, (state, action) => {
        if(action.payload.data.roles) {
         state.roles = action.payload.data.roles;
        }
        if(action.payload.data.abilities) {
         state.abilities = action.payload.data.abilities;
         state.selected = new RolesModel();
         state.selected.setAbilities(state.abilities);
        }
        state.apiState = ROLES.API_READY;
        state.view = ROLES.VIEW_OVERVIEW,
      state.key = uuid().slice(0, 8);
      state.error = null;
      history.replaceState(null, "", "/roles");
      
    }).addCase(roleStore.rejected, (state, action) => {
        state.error = action.payload;
        state.apiState = ROLES.API_READY;
        state.key = uuid().slice(0, 8);
    }).addCase(roleStore.pending, (state, action) => {
        state.apiState = ROLES.API_PROCESSING;
    });

    builder.addCase(roleDelete.fulfilled, (state, action) => {
        if(action.payload.data.roles) {
         state.roles = action.payload.data.roles;
        }
        if(action.payload.data.abilities) {
         state.abilities = action.payload.data.abilities;
         state.selected = new RolesModel();
         state.selected.setAbilities(state.abilities);
        }
        state.apiState = ROLES.API_READY;
        state.view = ROLES.VIEW_OVERVIEW,
      state.key = uuid().slice(0, 8);
      state.error = null;
    }).addCase(roleDelete.rejected, (state, action) => {
        state.apiState = ROLES.API_READY;
        state.error = action.payload;
        state.key = uuid().slice(0, 8);
    }).addCase(roleDelete.pending, (state, action) => {
        state.apiState = ROLES.API_PROCESSING;
    });

    builder.addCase(rolesoverview.fulfilled, (state, action) => {
        if(action.payload.data.roles) {
         state.roles = action.payload.data.roles;
        }
        if(action.payload.data.abilities) {
         state.abilities = action.payload.data.abilities;
         state.selected = new RolesModel();
         state.selected.setAbilities(state.abilities);
        }
        if(action.payload.data.storage) {
        state.storage = action.payload.data.storage;
        }
        state.apiState = ROLES.API_READY;
      state.key = uuid().slice(0, 8);
      state.error = null;
    }).addCase(rolesoverview.rejected, (state, action) => {
        state.apiState = ROLES.API_READY;
        state.error = action.payload;
        state.key = uuid().slice(0, 8);
    }).addCase(rolesoverview.pending, (state, action) => {
        state.apiState = ROLES.API_PROCESSING;
    });
   
    builder.addMatcher(
      (action) => action.type == 'switchtenant/fulfilled',
      (state, action) => {
            state.roles = [];
            state.abilities = [];
          state.selected = new RolesModel();
          state.selected.setAbilities(state.abilities);
          state.apiState = ROLES.API_INIT;
          state.view = ROLES.VIEW_OVERVIEW;
       });
    
  }
});

export const rolesoverview = createAsyncThunk(ROLES.VIEW_OVERVIEW, async (data, event) => {
    let response = null;
    try {
          response = await RolesAPI.index()
    } catch (err) {
      return event.rejectWithValue({status: err.response.status, statusText: err.response.statusText, data: err.response.data})
    }
    return response.data;
  }
)

export const rolesEdit = createAsyncThunk(ROLES.VIEW_DETAIL, async (data, event) => {
    let response = null;
    try {
          response = await RolesAPI.get(data);
    } catch (err) {
      return event.rejectWithValue({status: err.response.status, statusText: err.response.statusText, data: err.response.data})
    }
    return response.data;
  }
)

export const roleStore = createAsyncThunk(ROLES.ACTION_STORE, async (data, event) => {
    let response = null;
    try {
          response = await RolesAPI.store(data);
    } catch (err) {
      return event.rejectWithValue({status: err.response.status, statusText: err.response.statusText, data: err.response.data})
    }
    return response.data;
  }
)

export const roleDelete = createAsyncThunk(ROLES.API_DELETE, async (data, event) => {
    let response = null;
    try {
          response = await RolesAPI.delete(data);
    } catch (err) {
      return event.rejectWithValue({status: err.response.status, statusText: err.response.statusText, data: err.response.data})
    }
    return response.data;
  }
)

export const getRoleForUser = createAsyncThunk(ROLES.VIEW_DETAIL_USER, async (data, event) => {
    let response = null;
    try {
          response = await RolesAPI.getforuser(data);
    } catch (err) {
      return event.rejectWithValue({status: err.response.status, statusText: err.response.statusText, data: err.response.data})
    }
    return response.data;
  }
)

export const { cancel, newRol } = RolesReducer.actions;
export default RolesReducer.reducer